import * as XLSX from 'xlsx';

const HOST = process.env.REACT_APP_HOST;
const DEFAULT_IMG = 'storage/images/system/product-default.png';
const LOGO_IMG_PATH = HOST + 'storage/images/logos/';

const getImage = (url)=>{
    if (url && url.includes('storage')) {
        return HOST + url
    } else if(url) {
        return url;
    } else {
        return HOST + DEFAULT_IMG;
    }
}

const currencyFormater  = (value, rounded=false)=>{
    if (rounded) {
        value = Math.round(value);
    }
    return new Intl.NumberFormat('es-CO', { style: 'currency', currency: 'COP' }).format(value)
}

// columnFormats (opcional): un valor por columna, alineado con `headers` —
// 'currency' | 'percent' | null/undefined (sin formato). No convierte el
// dato — un porcentaje sigue guardado como 66, no 0.66 — solo cambia como
// Excel lo muestra (numFmt de la celda), asi que no hay que tocar cada
// calculo de los reportes para que el Excel se vea con formato real en
// vez de numeros en texto plano.
const downloadExcel = (headers, rows, fileName = 'Reporte', sheetName, columnFormats = []) => {
  const date  = new Date().toISOString().slice(0, 10);
  const sheet = (sheetName || fileName).slice(0, 31);
  const data  = [headers, ...rows];

  const worksheet = XLSX.utils.aoa_to_sheet(data);

  if (columnFormats.length > 0) {
    rows.forEach((row, ri) => {
      columnFormats.forEach((fmt, ci) => {
        if (!fmt) return;
        const cell = worksheet[XLSX.utils.encode_cell({ r: ri + 1, c: ci })];
        if (!cell || typeof cell.v !== 'number') return;
        if (fmt === 'currency') cell.z = '"$"#,##0';
        if (fmt === 'percent') cell.z = '0"%"';
      });
    });
  }

  // Ancho automático por columna (máx 55 caracteres)
  worksheet['!cols'] = headers.map((_, ci) => ({
    wch: Math.min(
      data.reduce((max, row) => Math.max(max, String(row[ci] ?? '').length), headers[ci].length) + 2,
      55
    ),
  }));

  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, sheet);
  XLSX.writeFile(workbook, `${fileName} ${date}.xlsx`);
};


// Price * (1 + tax%) rounded to the nearest integer (Colombian COP has no decimals)
function priceWithTax(price, taxes) {
  return Math.round(parseFloat(price) * ((parseFloat(taxes) / 100) + 1));
}

// Just the tax portion, rounded
function taxAmount(price, taxes) {
  return Math.round(parseFloat(price) * parseFloat(taxes) / 100);
}

export { currencyFormater, getImage, downloadExcel, priceWithTax, taxAmount, HOST, DEFAULT_IMG, LOGO_IMG_PATH };